import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { constructSeries } from './functions'
import { array, func } from 'prop-types'
import trofeu from '../../assets/trofeu.png'
import { Typography, styled } from '@mui/material'

const TrophImg = styled('img')`
  width: 40%;
  margin: auto;
  display: block;
  margin-top: 3rem;
`
const RadialBar = ({ postagens = [], changeMeta }) => {
  const [pageCount, setPageCount] = useState(0)
  const [series, setSeries] = useState([])
  const [color, setColor] = useState('#185273')
  const [meta, setMeta] = useState(false)

  useEffect(() => {
    init(postagens)
  }, [postagens])

  const init = async posts => {
    const pageCount = await constructSeries(posts, 'radial')
    setPageCount(pageCount)
  }

  function sendMeta() {
    changeMeta(meta)
  }

  useEffect(() => {
    sendMeta()
  }, [meta])

  useEffect(() => {
    setSeries([(pageCount * 100) / 2400])

    if (pageCount >= 2400) {
      setColor('#FFD700')
      setMeta(true)
    } else {
      setColor('#185273')
      setMeta(false)
    }
  }, [pageCount])

  const options = {
    chart: {
      type: 'radialBar',
      offsetY: -10
    },
    colors: [color],
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: '50%'
        },
        track: {
          dropShadow: {
            enabled: true,
            top: 2,
            left: 1,
            blur: 2,
            opacity: 0.15
          }
        },
        startAngle: -135,
        endAngle: 135,
        dataLabels: {
          name: {
            fontSize: '1.4rem',
            color: 'black',
            offsetY: 120
          },
          value: {
            offsetY: 0,
            fontSize: '60px',
            color: 'black',
            formatter: function (val) {
              return Math.round((val / 100) * 2400)
            }
          },
          formatter: () => {
            return 1
          }
        }
      }
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        shadeIntensity: 0.15,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 65, 91]
      }
    },
    stroke: {
      dashArray: 3
    },

    labels: [meta ? `Meta atingida` : `Meta: 2400`]
  }

  return (
    <div
      style={{
        height: '86%'
      }}
    >
      {meta ? (
        <div>
          <TrophImg src={trofeu} />
          <Typography
            sx={{
              fontSize: '1.75rem',
              fontWeight: 'bold',
              textAlign: 'center'
            }}
          >
            Páginas Lidas:
          </Typography>
          <Typography
            sx={{
              borderRadius: '0.3rem',
              fontSize: '2rem',
              fontWeight: 'bold',
              textAlign: 'center',
              color: 'darkorange'
            }}
          >
            {pageCount}
          </Typography>
        </div>
      ) : (
        <Chart
          type="radialBar"
          options={options}
          series={series}
          height="110%"
        />
      )}
    </div>
  )
}

RadialBar.propTypes = {
  postagens: array,
  changeMeta: func
}

export default RadialBar
